import React, { Component } from 'react';
import styled from 'styled-components';
import TextIcon from '../../../assets/TextIcon';
import { Card, Section } from '../../common';
import CompanyTitle from './Header/components/CompanyTitle';
import { map } from 'ramda';
import SocialIcons from '../../common/SocialIcons';

export default class Contact extends Component {
  render() {
    const {
      contact: { social, address },
      company,
    } = this.props;

    return (
      <BackgroundWrapper>
        <ContactSection>
          <Vertical>
            <ProjectCard key={5} title="Kontakt na nás.">
              <CompanyTitle {...company} />
              <AddressWrapper>
                {map(line => <div key={line}>{line}</div>)(address.lines)}
                <SocialIcons social={social} />
              </AddressWrapper>
            </ProjectCard>
          </Vertical>
          <TextUsCard key={2} title="Ozvi se nám!">
            <TextWrapper>
              <TextIcon />
              <TextUsTitle>Chces se k nám přidat nebo jen pokecat?</TextUsTitle>
              <TextUsAction>Nápiš nám →</TextUsAction>
            </TextWrapper>
          </TextUsCard>
        </ContactSection>
      </BackgroundWrapper>
    );
  }
}

const AddressWrapper = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const TextUsTitle = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 40px;
  max-width: 270px;
`;

const TextUsAction = styled.div`
  color: #2158ee;
  text-decoration: underline;
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
`;

const Vertical = styled.div`
  & > *:first-child {
    margin-bottom: 16px;
  }
`;

const BackgroundWrapper = styled.div`
  background: #f2f5f7;
`;

const TextWrapper = styled.div`
  line-height: 24px;
  font-size: 14px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const TextUsCard = styled(Card)`
  padding: 32px 32px 48px;
  height: 260px;
  min-width: 320px;
`;

const ProjectCard = styled(Card)`
  padding: 32px 32px 48px;
  height: 260px;
  min-width: 320px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const ContactSection = styled(Section)`
  display: flex;
  flex-wrap: wrap;
  padding: 56px 0;
  justify-content: center;

  & > *:not(:last-child) {
    margin-right: 16px;
  }

  @media screen and (max-width: 768px) {
    & > *:first-child {
      margin-right: 0;
    }
  }
`;
